/* eslint id-length: 0 */
import {
  EY_CERTIFICATES_FIELD_NAMES,
  EY_CERTIFICATES_FIELD_NAMES_EDUCATIONAL,
  EY_CERTIFICATES_FIELD_NAMES_OTHER,
  getTranslationKey
} from "../helpers/custom_pptx_template";
import { imageMargin, imageSize, leftOffset, spaceSize, topOffset } from "./constants";
import {
  createCustomFieldContent,
  createPositions,
  createSidePanelTextContent,
  createSummary
} from "./helpers";
import { useEYPptxOptions } from "./use_ey_pptx_options";

export const useLocalExportBuildEYPptx = (data, config, order, pptxgen, t, formatDate) => {
  const { _originalData, avatar, customTypes, logo, positions, summary } = data;
  const { templateKey, isBlindModeOn, hidden } = config;

  const filteredCertificatesTypeNames: string[] = order.filter((itemName) =>
    EY_CERTIFICATES_FIELD_NAMES.includes(itemName)
  );
  const filteredCertificatesTypes = customTypes.filter(({ type }) =>
    filteredCertificatesTypeNames.includes(type.name)
  );
  const filteredOrder = order.filter((itemName) => !hidden[itemName]);
  const showSummary = filteredOrder.includes("summary") && !!summary;
  const showExperience = filteredOrder.includes("experience");
  const certificatesTypesToShow = customTypes.filter(
    ({ type, text }) => filteredCertificatesTypeNames.includes(type.name) && text
  );
  const showCertificates = filteredCertificatesTypes.length && certificatesTypesToShow.length > 0;
  const showEducationalCertificates =
    showCertificates &&
    !!certificatesTypesToShow.find(
      ({ type, text }) => EY_CERTIFICATES_FIELD_NAMES_EDUCATIONAL.includes(type.name) && text
    );
  const showOtherCertificates =
    showCertificates &&
    !!certificatesTypesToShow.find(
      ({ type, text }) => EY_CERTIFICATES_FIELD_NAMES_OTHER.includes(type.name) && text
    );
  const {
    educationalCertificatesTextOptions,
    otherCertificatesTextOptions,
    experienceTextOptions,
    leftSidePanelTextOptions,
    summaryTextOptions,
    slideConfig,
    logoOptions
  } = useEYPptxOptions({
    avatar,
    summary,
    filteredCertificatesTypes,
    showCertificates,
    showEducationalCertificates,
    showOtherCertificates,
    logo
  });

  const pptx = new pptxgen();
  pptx.defineSlideMaster(slideConfig);
  const slide = pptx.addSlide({ masterName: "RESUME" });
  pptx.layout = "LAYOUT_4x3";

  const translationKey = getTranslationKey(templateKey);

  // left column (sidebar)
  if (avatar && !isBlindModeOn) {
    slide.addImage({
      x: imageMargin + leftOffset,
      y: spaceSize + topOffset,
      w: imageSize,
      h: imageSize,
      data: avatar,
      rounding: true
    });
  }

  const sidePanelTextContent = createSidePanelTextContent(
    data,
    config,
    customTypes,
    order,
    t,
    translationKey,
    leftSidePanelTextOptions
  );

  slide.addText(sidePanelTextContent, {
    placeholder: "leftSidePanelText"
  });

  // logo
  slide.addImage(logoOptions);

  // right panel
  if (showSummary) {
    slide.addText(t(`${translationKey}.summary`), { placeholder: "summaryHeader" });
    slide.addText(createSummary(summary, summaryTextOptions), { placeholder: "summaryText" });
  }

  if (showExperience) {
    slide.addText(t(`${translationKey}.positions`), { placeholder: "experienceHeader" });
    slide.addText(
      createPositions(positions, _originalData.internal_experiences, experienceTextOptions, formatDate),
      {
        placeholder: "experienceText"
      }
    );
  }

  if (showCertificates) {
    const educationalCertifiactesContent = createCustomFieldContent(
      certificatesTypesToShow,
      EY_CERTIFICATES_FIELD_NAMES_EDUCATIONAL,
      educationalCertificatesTextOptions
    );
    const otherCertifiactesContent = createCustomFieldContent(
      certificatesTypesToShow,
      EY_CERTIFICATES_FIELD_NAMES_OTHER,
      otherCertificatesTextOptions
    );

    if (showEducationalCertificates) {
      slide.addText(t(`${translationKey}.certificatesEducational`), {
        placeholder: "educationalCertificatesHeader"
      });
      slide.addText(educationalCertifiactesContent, {
        placeholder: "educationalCertificatesText"
      });
    }
    if (showOtherCertificates) {
      slide.addText(t(`${translationKey}.certificates`), {
        placeholder: "otherCertificatesHeader"
      });
      slide.addText(otherCertifiactesContent, {
        placeholder: "otherCertificatesText"
      });
    }
  }

  return pptx;
};
